import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_CULTURES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_CULTURES,
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_FIELDS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_FIELDS,
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_MATERIALS_VOLUMES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_MATERIALS_VOLUMES,
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_PRODUCT_VOLUMES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_PRODUCT_VOLUMES,
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_RELATED_OBJECTS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_RELATED_OBJECTS,
	},
}
